import { useQuery } from '@tanstack/react-query';
import { Rank } from '@domain/insights/models/Rank';
import { container } from '@infrastructure/container';

export const useRank = (rankId: string) => {
    const {
        data: rank,
        isLoading: isLoadingRank,
        error: rankError
    } = useQuery<Rank>({
        queryKey: ['rank', rankId],
        queryFn: async () => {
            const result = await container.insightsRepository.getRankById(rankId);
            if (result.status === 'error') throw new Error(result.error.message);
            return result.data;
        },
        enabled: !!rankId,
        refetchOnWindowFocus: false,
        staleTime: 0,
        refetchOnMount: true,
    });

    return {
        rank,
        isLoading: isLoadingRank,
        error: rankError
    };
};

